
import Vue from 'vue';
import EventBus from '@/plugins/event-bus';
import HorarioService from '@/services/HorarioService';
import { Horario } from '@/models/Horario';
import LicenciaService from '@/services/LicenciaService';
import rules from '@/mixins/rules';
import { VForm } from '@/types/formvalidate';
import { min } from 'moment';

export default Vue.extend({
    mixins: [rules],
    name: 'Extraordinario',
    props: {
        selectedLicencia: {
            type: Object,
        },
        open:{
            type: Boolean,
            default: false,
        },
        actualizar:{
            type: Boolean,
            default: false,
        },
        solicitud:{
            type: Object,
        },
        tipo: {
            type: String,
            default: 'EXTRA'
        }
    },
    computed: {
        form(): VForm {
            return this.$refs.form as VForm
        },
        minDate(){
            if(!this.horarios.length){
                return new Date();
            }
            const firstArrayFechas = this.horarios[0];
            if (firstArrayFechas.fecha.length > 0) {
                const fecha = firstArrayFechas.fecha as any;
                const firstDate = new Date(fecha[0] + ' 00:00:00');
                // Obtener el primer dia del mes de la fecha inicial
                const lastDate = new Date(firstDate.getFullYear(), firstDate.getMonth(), 1);
                return lastDate.toISOString().split('T')[0];
            }
        },
        maxDate(){
            if(!this.horarios.length){
                return new Date();
            }
            const firstArrayFechas = this.horarios[0];
            if (firstArrayFechas.fecha.length > 0) {
                const fecha = firstArrayFechas.fecha as any;
                const firstDate = new Date(fecha[0] + ' 00:00:00');
                // Obtener el primer dia del mes de la fecha inicial
                const lastDate = new Date(firstDate.getFullYear(), firstDate.getMonth(), 1);
                // Obtener el ultimo dia del mes de la fecha inicial
                const lastDateOfMonth = new Date(lastDate.getFullYear(), lastDate.getMonth() + 1, 0);
                return lastDateOfMonth.toISOString().split('T')[0];
            }
        },
    },
    watch: {
        selectedLicencia: {
            handler(newVal){
                this.licencia = this.selectedLicencia;
            }
        },
        actualizar(newVal){
            this.findSolicitudExtraordinaria();
        },
        solicitud(newValue: any) {
            if (newValue) {
                if (newValue.estatus_fiscalizacion == 4) {
                    this.estatus_fiscalizacion = 4;
                    this.disabled = true;
                }
            }
        },
        open(value){
            if (this.open && !this.actualizar) {
                this.getEstablecimiento();
                this.getHorarioExtraordinario();
            }
        }
    },
    mounted(){
        this.licencia = this.selectedLicencia;
        this.getEstablecimiento();
        this.getEstablecimientos();
    },
    data() {
        return {
            horario: null as any,
            menu: false,
            disabled: false,
            horarios : [] as Horario[],
            licencia: null as any,
            deteleHorarios: [] as any[],
            duracionHoras: [] as number[],
            establecimientos: [] as any[],
            establecimiento_id: null as any,
            estatus_fiscalizacion: null as any,
            cantidad_personas: null as any,
            dates: [] as any,
            horas: [] as any,
            grupo_horario_actual: 1,
            gruposHorarios: []
        }
    },
    methods: {
        allowedDates(val: any){
            let existeHorario = this.horarios.find((h: any) => h.fecha === val);
            if (this.tipo == 'EXTRA') {
                let horario = this.buscarHorarios(val);
                return horario.horas.length > 0 && !existeHorario;
            } else if (this.tipo == 'VARIEDAD') {
                return !existeHorario;
            }
        },
        getHorarioExtraordinario(establecimiento_id: any = null){
            if (establecimiento_id) {
                this.establecimiento_id = establecimiento_id;
            }
            this.horarios = [];
            HorarioService.getHorarioExtraordinario(this.licencia.id)
            .then((response) => {
                this.horario = response.data;
                if (!this.actualizar) {
                    this.horarios.push(new Horario());
                }
                
            });
            //console.log("horarios",this.horarios);
        },
        close(){
            this.deteleHorarios = [];
            this.horarios = [];
            this.establecimiento_id = null;
            this.estatus_fiscalizacion = null;
            this.cantidad_personas = null;
            this.horario = null;
            EventBus.$emit("close-extraordinario");
        },
        addHorario(){
            /*if(this.horarios.length == 2){
                this.$toast.error('Solo se puede tener dos horarios');
                return;
            }*/
          let miniHorario = new Horario();
            if (this.horarios.length > 0) {
                const ultimoGrupoHorario = Math.max(...this.horarios.map(h => h.grupo_horario));
                miniHorario.hora_inicio = this.horarios[this.horarios.length - 1].hora_inicio;
                miniHorario.hora_fin = this.horarios[this.horarios.length - 1].hora_fin;
                miniHorario.horas_solicitadas = this.horarios[this.horarios.length - 1].horas_solicitadas;
                miniHorario.grupo_horario = ultimoGrupoHorario + 1;
                this.horarios.push(miniHorario);
            }else{
                this.horarios.push(new Horario());
            }
          this.grupo_horario_actual++;
            
        },
        deleteHorario(index: any){
            if (this.horarios[index].id != 0) {
                this.deteleHorarios.push(this.horarios[index].id);
            }
            this.horarios.splice(index, 1);
        },
        buscarHorarios(fecha: any){
            let dia = this.obtenerDiaSemana(fecha);
            let horarios = this.horario.horario_extraordinario.horarios.find((horario: any) => horario.dia.nombre === dia);
            if (horarios === undefined) {
                return {
                    horas: [],
                    dia: dia,
                };
            }
            let horaIncio = horarios.segmento_horario.hora_inicio;
            let horaFin = horarios.segmento_horario.hora_fin;
            let horas = this.generarArregloHoras(horaIncio, horaFin);
            console.log("horas",horas);
            return {
                horas: horas,
                dia: dia,
            };
        },
        generarArregloHoras(horaInicio: any, horaFin: any) {
            const [horaInicioH, minutoInicio, segundoInicio] = horaInicio.split(':').map(Number);
            const [horaFinH, minutoFin, segundoFin] = horaFin.split(':').map(Number);

            const arregloHoras = [];
            let horaActual = new Date(2024, 0, 1, horaInicioH, minutoInicio, segundoInicio);

            while (
                horaActual.getHours() !== horaFinH ||
                horaActual.getMinutes() !== minutoFin ||
                horaActual.getSeconds() !== segundoFin
            ) {
                arregloHoras.push(
                horaActual.toLocaleTimeString('en-US', {
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit',
                    hour12: false // Formato de 24 horas
                })
                );
                horaActual.setHours(horaActual.getHours() + 1);
            }

            // Agrega la última hora (horaFin)
            arregloHoras.push(
                horaActual.toLocaleTimeString('en-US', {
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: false // Formato de 24 horas
                })
            );

            return arregloHoras.map(hora => (hora === '24:00:00' ? '00:00:00' : hora));
        },
        obtenerDiaSemana(fecha: any) {
            let diasSemana = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
            let fechaObj = new Date(fecha + ' 00:00:00');
            let numeroDiaSemana = fechaObj.getDay();
            let nombreDiaSemana = diasSemana[numeroDiaSemana];
            return nombreDiaSemana;
        },
        save(){
            this.disabled = true;
            if (!this.form.validate()) {
                this.$toast.error('Complete la información');
                this.disabled = false;
                return;
            }
            if(this.validar(this.horarios)){
                this.disabled = false;
                return;
            }
            let newHorarios=[] as any;
            let datos =[] as any;
                this.horarios.forEach((value : any) => {
                datos = value.fecha;
                let actual = value;
                datos.forEach((value : any) => {
                        let hor = new Horario();
                        hor.id = actual.id;
                        hor.fecha = value;
                        hor.hora_fin = actual.hora_fin;
                        hor.horas_aprobadas = actual.horas_aprobadas;
                        hor.horas_solicitadas = actual.horas_solicitadas;
                        hor.aprobado = actual.aprobado;
                        hor.hora_inicio = actual.hora_inicio;
                        hor.grupo_horario = actual.grupo_horario
                        newHorarios.push(hor);
                                });
                });
            LicenciaService.saveSolicitudFiscalizacion(this.selectedLicencia.id, {
                horarios: newHorarios,
                establecimiento_id: this.establecimiento_id,
                tipo: this.tipo,
                cantidad_personas: this.cantidad_personas,
            })
            .then((response) => {
                if (response.data.success) {
                    this.disabled = false;
                    this.$toast.success(response.data.message);
                    EventBus.$emit("save-extraordinario");
                    this.close();
                } else {
                    this.disabled = false;
                    this.$toast.error(response.data.message);
                }
            })
            .catch((error) => {
                this.disabled = false;
                ////this.$toast.error(error.response.data.message);
            })
        },
        async findSolicitudExtraordinaria(){
            //este va a tener una funcionalidad distinta cuando establecimiento sea igual a 3 
            if (this.actualizar && this.solicitud) {
                await LicenciaService.findSolicitudExtraordinaria(this.licencia.id, this.solicitud.id)
                .then(async (response) => {
                    this.establecimiento_id = this.solicitud.establecimiento_id;
                    if (response.data.tipo == 'VARIEDAD') {
                        this.cantidad_personas = response.data.cantidad_personas;
                    }
                    await HorarioService.getHorarioExtraordinario(this.licencia.id)
                    .then((response) => {
                        this.horario = response.data;
                    });
                    if(this.establecimiento_id != 3){
                        //aqui recorro las fechas para meterlas en uno solo 
                            let newData = []  as any;
                            let datos = []  as any;
                            newData = response.data.solicitudDetalles;
                            response.data.solicitudDetalles.forEach((value : any) => {
                                datos.push(value.fecha)
                            });
                            newData.fecha = datos;
                            this.horarios = newData;
                            console.log('horarios', this.horarios);
                    }else{
                        //aqui me falta pensar como hacer la logica para que este se llene con uno o dos datos
                        /*let newData = []  as any;//primer horario
                        let datos2 = [] as any;//segundo horario
                        let datos = []  as any; //datos son las fechas
                        response.data.solicitud_detalles.forEach((value : any,index:any) => {
                            let dia = this.obtenerDiaSemana(value.fecha);
                            if(dia =="Domingo"){
                                if(datos2.length==0){
                                    newData[1] = response.data.solicitud_detalles[index];
                                }
                                datos2.push(value.fecha)
                            }else{
                                if(datos.length==0){
                                    newData[0] = response.data.solicitud_detalles[index];
                                }
                                datos.push(value.fecha)
                            }
                        });
                        if(datos.length !=0 && datos2.length!=0){
                            newData[0].fecha = datos; 
                            newData[1].fecha = datos2; 
                        }
                        if(datos.length ==0 && datos2.length!=0){
                            newData[0].fecha = datos2; 
                        }
                        if(datos.length !=0 && datos2.length ==0){
                            newData[0].fecha = datos; 
                        }                         
                        this.horarios = newData;*/
                        let newData = []  as any;
                            let datos = []  as any;
                            newData = response.data.solicitudDetalles;
                            response.data.solicitudDetalles.forEach((value : any) => {
                                datos.push(value.fecha)
                            });
                            newData.fecha = datos;
                            this.horarios = newData;
                            console.log('horarios', this.horarios);
                    }
                })
                .catch((error) => {
                    console.log(error.response.data);
                })
            }
        },
        async update() {
            this.disabled = true;
            if(this.validar(this.horarios)){
                this.disabled = false;
                return;
            }
            let newHorarios=[] as any;
            let datos =[] as any;
                this.horarios.forEach((value : any) => {
                datos = value.fecha;
                let actual = value;
                datos.forEach((value : any) => {
                        let hor = new Horario();
                        hor.fecha = value;
                        hor.hora_fin = actual.hora_fin;
                        hor.horas_aprobadas = actual.horas_aprobadas;
                        hor.horas_solicitadas = actual.horas_solicitadas;
                        hor.aprobado = actual.aprobado;
                        hor.hora_inicio = actual.hora_inicio;
                        hor.grupo_horario = actual.grupo_horario
                        newHorarios.push(hor);
                                });
                });
            await LicenciaService.actualizarSolicitudFiscalizacion(this.licencia.id, this.solicitud.id, {
                horarios: newHorarios,
                delete_horarios: this.deteleHorarios,
                establecimiento_id: this.establecimiento_id,
                tipo: this.tipo,
                cantidad_personas: this.cantidad_personas,
            })
            .then((response) => {
                if (response.data.success) {
                    /* this.getHorarioExtraordinario(); */
                    /* this.findSolicitudExtraordinaria(); */
                    this.$toast.success(response.data.message);
                    this.close();
                } else {
                    this.$toast.error(response.data.message);
                }
                this.disabled = false;
            })
            .catch((error) => {
                ////this.$toast.error(error.response.data.message);
                this.disabled = false;
            })
        },
        /*calcularDuracion(index: "id" | "fecha" | "hora_inicio" | "hora_fin" | "horas_solicitadas" | "horas_aprobadas" | "aprobado" | "grupo_horario") {
            if (this.horarios[index].hora_inicio == this.horarios[index].hora_fin) {
                this.horarios[index].horas_solicitadas = 0;
                this.horarios[index].hora_fin = null;
                this.$toast.error('Las horas de inicio y fin no pueden ser iguales.');
                return;
            }
            const horaInicio = new Date(`2024-01-01 ${this.horarios[index].hora_inicio}`);
            const horaFin = new Date(`2024-01-01 ${this.horarios[index].hora_fin}`);

            if (horaFin < horaInicio) {
                horaFin.setDate(horaFin.getDate() + 1);
            }

            const diferenciaMillis = horaFin.getTime() - horaInicio.getTime();

            const diferenciaHoras = diferenciaMillis / (1000 * 60 * 60);

            this.horarios[index].horas_solicitadas = diferenciaHoras;
        },*/
        validarHoras(index: number) {
          const horaInicio = this.horarios[index].hora_inicio;
          const horaFin = this.horarios[index].hora_fin;

          if (!horaInicio || !horaFin) {
            this.horarios[index].horas_solicitadas = 0;
            return false;
          }

          if (horaInicio === horaFin) {
            this.horarios[index].horas_solicitadas = 0;
            this.$set(this.horarios[index], 'hora_fin', null);
            this.$toast.error('Las horas de inicio y fin no pueden ser iguales.');
            return false;
          }

          const horaIni = new Date(`2024-01-01 ${this.horarios[index].hora_inicio}`);
          const horaFini = new Date(`2024-01-01 ${this.horarios[index].hora_fin}`);

          if (horaFini < horaIni) {
            horaFini.setDate(horaFini.getDate() + 1);
          }

          const diferenciaMillis = horaFini.getTime() - horaIni.getTime();

          const diferenciaHoras = diferenciaMillis / (1000 * 60 * 60);

          this.horarios[index].horas_solicitadas = diferenciaHoras;

          return true;
        },
        getEstablecimientos(){
            HorarioService.getEstablecimientos()
            .then((response) => {
                this.establecimientos = response.data;
            })
            .catch((error) => {
                //console.log(error.response.data);
            })
        },
        getEstablecimiento(){
            HorarioService.getEstablecimiento(this.licencia.locacion_id)
            .then((response) => {
                this.establecimiento_id = response.data.giro_opb.giro_tipo_patente.establecimiento_id;  
                if(this.establecimiento_id == 1){
                    this.horas = ['22:00:00', '23:00:00', '00:00:00']
                }
                if(this.establecimiento_id == 3){
                    this.horas = ['17:00:00','18:00:00','19:00:00','20:00:00','21:00:00','22:00:00', '23:00:00', '00:00:00', '01:00:00', '02:00:00', '03:00:00']
                }
                if(this.establecimiento_id == 2){
                    this.horas = [ '23:00:00', '00:00:00', '01:00:00']
                }
                if(this.establecimiento_id == 4){
                    this.horas = ['23:00:00', '00:00:00', '01:00:00', '02:00:00', '03:00:00']
                }
            })
            .catch((error) => {
                //console.log(error.response.data);
            })
        },
        validar(datos:any){
            //cuando retorne un true es por que fallo
        if(this.establecimiento_id == 1 || this.establecimiento_id ==4){
           let sies = false;
           datos[0].fecha.forEach((value : any) => {
            let dia = this.obtenerDiaSemana(value);
            if(dia == "Domingo"){
                sies = true;
            }
             });
        if(sies){
            this.$toast.error('No se permite el dia Domingo');
            return true;
        }
        }
        if(this.establecimiento_id == 3){
            let domingos = 0;
            let entres = 0;
            let normal = ['23:00:00', '00:00:00', '01:00:00', '02:00:00', '03:00:00']
            let  domingo = ['17:00:00','18:00:00','19:00:00','20:00:00','21:00:00','22:00:00', '23:00:00']
            //aqui debo validar 
            //si hay dos arreglos que uno tenga puro domingo y que el otro no tenga domingo
            //validar sus horas seleccionadas en el perimetro
            if(datos.length == 2){
                let entre = 0;
                let dom = 0;

            datos[0].fecha.forEach((value : any) => {
            let dia = this.obtenerDiaSemana(value);

            if(dia == "Domingo"){
                dom++;
            }else{
                entre++;
            }
             });
             if(dom != 0 && entre != 0){
                this.$toast.error('No se permite agregar domingo si selecciono un dia entre lunes y sabado');
                return true;
            }
            if(dom != 0 && entre==0 ){
                if(!domingo.includes(datos[0].hora_inicio) || !domingo.includes(datos[0].hora_fin)){
                    this.$toast.error('Solo se puede agregar horarios entre las 17:00:00 y las 23:00:00 horas los domingo');
                    return true;
                }
            }
            if(entre != 0 ){
                if(!normal.includes(datos[0].hora_inicio) || !normal.includes(datos[0].hora_fin)){
                    this.$toast.error('Solo se puede agregar horarios entre las 23:00:00 y las 03:00:00 horas entre lunes a sabado');
                    return true;
                }
            }

            if(dom == 1){ domingos++;}
            if(entre == 1){ entres++;}
                //////////////////////////////////////
                entre = 0;
                dom = 0;

            datos[1].fecha.forEach((value : any) => {
            let dia = this.obtenerDiaSemana(value);

            if(dia == "Domingo"){
                dom++;
            }else{
                entre++;
            }
             });
             if(dom != 0 && entre != 0){
                this.$toast.error('No se permite agregar domingo si selecciono un dia entre lunes y sabado');
                return true;
            }
            if(dom != 0 ){
                if(!domingo.includes(datos[1].hora_inicio) || !domingo.includes(datos[1].hora_fin)){
                    this.$toast.error('Solo se puede agregar horarios entre las 17:00:00 y las 23:00:00 horas los domingo');
                    return true;
                }
            }
            if(entre != 0 ){
                if(!normal.includes(datos[1].hora_inicio) || !normal.includes(datos[1].hora_fin)){
                    this.$toast.error('Solo se puede agregar horarios entre las 23:00:00 y las 03:00:00 horas entre lunes a sabado');
                    return true;
                }
            }

            }else{
                //solo uno
                let entre = 0;
                let dom = 0;

            datos[0].fecha.forEach((value : any) => {
            let dia = this.obtenerDiaSemana(value);

            if(dia == "Domingo"){
                dom++;
            }else{
                entre++;
            }
             });
             if(dom != 0 && entre != 0){
                this.$toast.error('No se permite agregar domingo si selecciono un dia entre lunes y sabado');
                return true;
            }
            if(dom != 0 ){
                if(!domingo.includes(datos[0].hora_inicio) || !domingo.includes(datos[0].hora_fin)){
                    this.$toast.error('Solo se puede agregar horarios entre las 17:00:00 y las 23:00:00 horas los domingo');
                    return true;
                }
            }
            if(entre != 0 ){
                if(!normal.includes(datos[0].hora_inicio) || !normal.includes(datos[0].hora_fin)){
                    this.$toast.error('Solo se puede agregar horarios entre las 23:00:00 y las 03:00:00 horas entre lunes a sabado');
                    return true;
                }
            }
            }
        }
        return false;
        },
    }
});
